module.exports = __webpack_public_path__ + "img/commission.0dbe8248.png";